import logLevel from 'loglevel';

type OptionalLogLevel = logLevel.LogLevelDesc | undefined;

const defaultLevel = process.env.REACT_APP_LOG_LEVEL as OptionalLogLevel;
if (defaultLevel) {
  logLevel.setDefaultLevel(defaultLevel);
}

export const basketLogger = createLogLevelWithPrefix(
  'BASKET',
  process.env.REACT_APP_LOG_LEVEL_BASKET as OptionalLogLevel
);
export const paymentLogger = createLogLevelWithPrefix(
  'PAYMENT',
  process.env.REACT_APP_LOG_LEVEL_BASKET as OptionalLogLevel
);

export default logLevel;

function createLogLevelWithPrefix(nameOrLogger, level?: logLevel.LogLevelDesc) {
  let log: logLevel.Logger;

  if (typeof nameOrLogger === 'string') {
    log = logLevel.getLogger(nameOrLogger);
  } else if (typeof nameOrLogger === 'object') {
    log = nameOrLogger;
  } else {
    log = logLevel;
  }

  const originalFactory = log.methodFactory;
  log.methodFactory = function(methodName, logLevel, loggerName) {
    var rawMethod = originalFactory(methodName, logLevel, loggerName);
    var prefix = loggerName ? `[${loggerName}]` : '';
    return function(message) {
      var args = Array.prototype.slice.call(arguments);
      return rawMethod.apply(this, [prefix, ...args]);
    };
  };

  log.setLevel(level ? level : log.getLevel());
  return log;
}
